import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagements from '../../../../engagements'
import * as allocation from '../allocation'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: allocation.RESOURCE.payload.dimension.partialId,
      partialId: allocation.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Engagement associated with this allocation.',
    isOptional: true,
    name: 'Engagement',
    partialId: PartialId.Standard.create('engagement'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        engagements.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
